// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-p_fh","advertDetailParameterList__header":"c-p_fi","advertDetailParameterList__list":"c-p_fj"};